import { render, staticRenderFns } from "./ReporteTrabajadores.vue?vue&type=template&id=5f8fe9d6&"
import script from "./ReporteTrabajadores.vue?vue&type=script&lang=js&"
export * from "./ReporteTrabajadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports